var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 319,
    viewBox: "0 0 298 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1533_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.926 3.66177C284.695 3.35952 285.092 2.47971 284.814 1.69667C284.535 0.913626 283.686 0.52387 282.918 0.826124L283.926 3.66177ZM19.3666 259.695C19.7138 260.447 20.5951 260.755 21.3351 260.383L33.3931 254.316C34.1331 253.944 34.4515 253.032 34.1042 252.28C33.757 251.527 32.8757 251.219 32.1358 251.592L21.4175 256.985L16.388 246.088C16.0408 245.336 15.1595 245.028 14.4196 245.4C13.6796 245.772 13.3613 246.684 13.7085 247.436L19.3666 259.695ZM232.255 22.3682L231.751 20.9504L231.665 20.9841L231.584 21.0282L232.255 22.3682ZM112.414 132.244L112.562 130.729L112.414 132.244ZM50.542 173.588L49.1501 173.101L50.542 173.588ZM114.846 132.442L114.698 133.957L114.846 132.442ZM196.497 41.8039L197.168 43.1439L196.497 41.8039ZM282.918 0.826124L280.36 1.83233L281.368 4.66798L283.926 3.66177L282.918 0.826124ZM275.243 3.84476L270.126 5.85719L271.134 8.69284L276.251 6.68041L275.243 3.84476ZM265.01 7.86963L259.893 9.88205L260.901 12.7177L266.018 10.7053L265.01 7.86963ZM254.776 11.8945L249.66 13.9069L250.668 16.7426L255.784 14.7301L254.776 11.8945ZM244.543 15.9193L239.426 17.9318L240.434 20.7674L245.551 18.755L244.543 15.9193ZM234.309 19.9442L231.751 20.9504L232.759 23.7861L235.318 22.7798L234.309 19.9442ZM231.584 21.0282L228.604 22.6479L229.946 25.3279L232.926 23.7082L231.584 21.0282ZM222.645 25.8871L216.685 29.1264L218.027 31.8065L223.987 28.5672L222.645 25.8871ZM210.725 32.3657L204.766 35.605L206.108 38.285L212.067 35.0457L210.725 32.3657ZM198.806 38.8443L195.826 40.4639L197.168 43.1439L200.148 41.5243L198.806 38.8443ZM195.826 40.4639C194.856 40.991 193.916 41.5595 193.005 42.1664L194.581 44.7055C195.415 44.1489 196.278 43.6275 197.168 43.1439L195.826 40.4639ZM187.857 46.3133C186.257 47.8566 184.802 49.538 183.505 51.3333L185.869 53.1115C187.058 51.465 188.393 49.9231 189.86 48.5079L187.857 46.3133ZM180.091 57.059C179.126 59.0586 178.334 61.1479 177.729 63.3027L180.571 64.0886C181.126 62.1127 181.853 60.1967 182.738 58.3628L180.091 57.059ZM176.497 69.8588C176.389 70.9594 176.329 72.0698 176.319 73.187L179.279 73.1528C179.288 72.1278 179.343 71.1094 179.442 70.1001L176.497 69.8588ZM176.319 73.187C176.309 74.1852 176.275 75.1772 176.217 76.1623L179.172 76.2828C179.233 75.2461 179.269 74.2026 179.279 73.1528L176.319 73.187ZM175.571 82.0835C175.253 84.0626 174.838 86.0078 174.331 87.9139L177.185 88.658C177.719 86.6497 178.157 84.6007 178.491 82.5163L175.571 82.0835ZM172.507 93.5911C171.801 95.4604 171.003 97.2832 170.12 99.0539L172.748 100.395C173.679 98.5293 174.519 96.609 175.264 94.6395L172.507 93.5911ZM167.195 104.244C166.132 105.926 164.988 107.549 163.768 109.107L166.059 110.981C167.343 109.341 168.549 107.632 169.668 105.861L167.195 104.244ZM159.877 113.591C158.507 115.018 157.068 116.373 155.566 117.65L157.425 119.975C159.007 118.63 160.522 117.204 161.963 115.702L159.877 113.591ZM150.88 121.241C149.264 122.353 147.591 123.382 145.869 124.323L147.216 127C149.03 126.01 150.791 124.926 152.492 123.755L150.88 121.241ZM140.585 126.861C138.793 127.61 136.957 128.266 135.085 128.825L135.856 131.743C137.829 131.154 139.763 130.462 141.651 129.674L140.585 126.861ZM129.427 130.192C127.537 130.543 125.617 130.796 123.673 130.946L123.833 133.977C125.881 133.819 127.904 133.552 129.895 133.182L129.427 130.192ZM117.883 131.086C116.924 131.058 115.96 131.005 114.993 130.927L114.698 133.957C115.715 134.039 116.729 134.095 117.738 134.124L117.883 131.086ZM114.993 130.927L114.385 130.877L114.09 133.907L114.698 133.957L114.993 130.927ZM113.169 130.778L112.562 130.729L112.267 133.759L112.875 133.808L113.169 130.778ZM112.562 130.729C111.601 130.651 110.643 130.596 109.687 130.565L109.531 133.603C110.44 133.632 111.353 133.684 112.267 133.759L112.562 130.729ZM103.923 130.654C101.992 130.778 100.077 130.996 98.1826 131.303L98.5853 134.305C100.387 134.013 102.209 133.806 104.046 133.688L103.923 130.654ZM92.5169 132.507C90.6402 133.001 88.7913 133.584 86.9758 134.254L87.9242 137.112C89.6514 136.475 91.4104 135.92 93.1957 135.45L92.5169 132.507ZM81.6098 136.527C79.8538 137.371 78.1374 138.299 76.4664 139.306L77.9244 141.919C79.5145 140.961 81.1477 140.079 82.8186 139.275L81.6098 136.527ZM71.5906 142.564C70.016 143.726 68.4925 144.963 67.0256 146.273L68.9408 148.549C70.3365 147.303 71.7862 146.125 73.2845 145.02L71.5906 142.564ZM62.8124 150.4C61.4747 151.838 60.1984 153.342 58.9893 154.91L61.295 156.767C62.4452 155.275 63.6593 153.844 64.932 152.476L62.8124 150.4ZM55.5925 159.763C54.5402 161.424 53.5582 163.142 52.6518 164.915L55.2661 166.284C56.1285 164.597 57.0626 162.963 58.0636 161.383L55.5925 159.763ZM50.1928 170.32C49.8258 171.235 49.478 172.162 49.1501 173.101L51.9339 174.074C52.2461 173.18 52.5771 172.298 52.9264 171.426L50.1928 170.32ZM49.1501 173.101L48.0845 176.152L50.8684 177.125L51.9339 174.074L49.1501 173.101ZM45.9534 182.255L43.8223 188.357L46.6061 189.33L48.7372 183.228L45.9534 182.255ZM41.6912 194.46L39.5601 200.562L42.3439 201.535L44.475 195.432L41.6912 194.46ZM37.429 206.664L35.2978 212.767L38.0817 213.74L40.2128 207.637L37.429 206.664ZM33.1667 218.869L31.0356 224.971L33.8195 225.944L35.9506 219.842L33.1667 218.869ZM28.9045 231.074L26.7734 237.176L29.5572 238.149L31.6883 232.047L28.9045 231.074ZM24.6423 243.279L22.5111 249.381L25.295 250.354L27.4261 244.251L24.6423 243.279ZM20.3801 255.483L19.3145 258.535L22.0983 259.507L23.1639 256.456L20.3801 255.483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1533_1710",
    x: 0.567871,
    y: 0.723755,
    width: 297.334,
    height: 317.817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1533_1710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1533_1710",
    result: "effect2_dropShadow_1533_1710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1533_1710",
    result: "effect3_dropShadow_1533_1710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1533_1710",
    result: "effect4_dropShadow_1533_1710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1533_1710",
    result: "effect5_dropShadow_1533_1710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1533_1710",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLine3);
export default __webpack_public_path__ + "static/media/mediaLine 3.6be71e403eaa3f384f5b1b563033a977.svg";
export { ForwardRef as ReactComponent };